const Builder = require('./BuilderBase');
const HiddenFor = require('./HiddenFor');

module.exports = class ValueSearch extends Builder {
    constructor(title, properties) {
        super('searchElement_ValueSearch', title, properties);
    }

    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }
};
